import { Outlet, useLocation, useOutletContext } from "react-router";
import { SettingsNav } from "@/app/(app)/settings/_components/settings-nav";
import { TabTransition } from "@/components/tab-transition";
import type { AppOutletContext } from "@/src/layouts/AppLayout";

export default function SettingsLayout() {
  const { pathname } = useLocation();
  // Settings pages sit one Outlet deeper than AppLayout, so without forwarding
  // they'd see no context. Pass AppLayout's context (incl. `infoResolved`) down
  // so a settings page can gate version-dependent fetches on /info/ hydration.
  const ctx = useOutletContext<AppOutletContext | null>();

  // Column on phones (nav becomes a horizontal tab bar), row on md+. SettingsNav
  // owns its own borders so they flip from bottom (mobile) to right (desktop).
  return (
    <div className="flex h-full flex-col md:flex-row">
      <div className="shrink-0">
        <SettingsNav />
      </div>
      <div className="min-w-0 flex-1 overflow-y-auto p-4 md:p-8">
        {/* Animate the section content in on every settings route switch. */}
        <TabTransition transitionKey={pathname}>
          <Outlet context={ctx} />
        </TabTransition>
      </div>
    </div>
  );
}
